import React from 'react';

export default function Toolbar(props) {
  const { osdInstance } = props;
  const buttons = [
    {
      id: 'full-page',
      label: 'Exit viewer',
      icon: 'exit',
      handler() {
        // Only attempt to exit full screen on supporting browsers or if set
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        props.setIsFullScreen(false);
      },
    },
    {
      id: 'zoom-in',
      label: 'Zoom in',
      icon: 'zoom-in',
      handler() {
        // Zoom using same method as in OSD source code
        osdInstance.viewport.zoomBy(osdInstance.zoomPerClick / 1.0);
        osdInstance.viewport.applyConstraints();
      },
    },
    {
      id: 'zoom-out',
      label: 'Zoom out',
      icon: 'zoom-out',
      handler() {
        // Zoom using same method as in OSD source code
        osdInstance.viewport.zoomBy(1.0 / osdInstance.zoomPerClick);
        osdInstance.viewport.applyConstraints();
      },
    },
    {
      id: 'options',
      label: 'Settings',
      icon: 'options',
      ariaControls: 'viewer__options',
      ariaExpanded: false,
      handler(e) {
        // Toggle the state
        props.setIsOptionsOpen((prevState) => !prevState);
      },
    },
  ];

  const renderButtons = () => {
    const buttonEls = buttons.map((button) => {
      let buttonAttrs = {
        id: `osd-btn-${button.id}`,
        className: 'viewer-button',
        type: 'button',
        title: button.label,
        onClick: button.handler,
      };

      if (button.ariaControls !== undefined) {
        buttonAttrs['aria-controls'] = button.ariaControls;
      }

      if (button.ariaExpanded !== undefined) {
        buttonAttrs['aria-expanded'] = props.isOptionsOpen;
      }

      if (button.id === 'options') {
        buttonAttrs.ref = props.optionsButtonRef;
        if (props.isOptionsOpen) {
          buttonAttrs.className = 'viewer-button viewer-button--active';
        }
      }

      return (
        <button key={button.id} {...buttonAttrs}>
          <span className="wrap">
            <svg className="icon">
              <use href={`/assets/images/icons.svg#${button.icon}`}></use>
            </svg>
            <span className="visually-hidden">{button.label}</span>
          </span>
        </button>
      );
    });
    return buttonEls;
  };

  return (
    <div id="viewer__osd-toolbar" className="viewer__osd-toolbar">
      {renderButtons()}
    </div>
  );
}
